@switch (lang | async) {
  @case ('da') {
    <h4>Oplysninger i henhold til § 5 TMG</h4>
    <p>AGROLAB GmbH</p>
    <p>Jenaer Str. 1</p>
    <p>84034 Landshut</p>

    <h4>Repræsenteret ved:</h4>
    <p>Dr. Paul Wimmer</p>
    <p>Dr. Torsten Zurmühl</p>
    <p>Michael Witiska</p>
    <p>Benoist Lasserre</p>

    <h4>Kontakt:</h4>
    <p>Tel: +49 0871 973091-0</p>
    <p>Fax: +49 0871 973091-99</p>
    <p>E-Mail: <a href="mailto:zentrale@agrolab.de">zentrale&#64;agrolab.de</a></p>

    <h4>Registerpost:</h4>
    <p>Registerbureau: Amtsgericht Landshut</p>
    <p>HRB 7152</p>

    <h4>Moms-ID:</h4>
    <p>Momsnummer i henhold §27a Umsatzsteuergesetz: DE DE 218 177 209.</p>

    <h4>Ansvarlig for indholdet i henhold til § 55 Afs. 2 RStV:</h4>
    <p>AGROLAB GmbH</p>
    <p>Renate Schwameis</p>
    <p>Jenaer Str. 1</p>
    <p>84034 Landshut</p>
    <p class="imprint-link">
      <a href="https://www.agrolab.com/da/kolofon.html" target="_blank">Virksomhedsoplysninger</a>
    </p>
  }
  @case ('de') {
    <h4>Angaben gemäß § 5 TMG</h4>
    <p>AGROLAB GmbH</p>
    <p>Jenaer Str. 1</p>
    <p>84034 Landshut</p>

    <h4>Vertreten durch:</h4>
    <p>Dr. Paul Wimmer</p>
    <p>Dr. Torsten Zurmühl</p>
    <p>Michael Witiska</p>
    <p>Benoist Lasserre</p>

    <h4>Kontakt:</h4>
    <p>Tel: +49 0871 973091-0</p>
    <p>Fax: +49 0871 973091-99</p>

    <p>E-Mail: <a href="mailto:zentrale@agrolab.de">zentrale&#64;agrolab.de</a></p>

    <h4>Registereintrag:</h4>
    <p>Registergericht: Amtsgericht Landshut</p>
    <p>HRB 7152</p>

    <h4>Umsatzsteuer-ID:</h4>
    <p>Umsatzsteuer-Identifikationsnummer gemäß §27a Umsatzsteuergesetz: DE DE 218 177 209.</p>

    <h4>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</h4>
    <p>AGROLAB GmbH</p>
    <p>Renate Schwameis</p>
    <p>Jenaer Str. 1</p>
    <p>84034 Landshut</p>
    <p class="imprint-link">
      <a href="https://www.agrolab.com/de/impressum.html" target="_blank">Impressum</a>
    </p>
  }
  @case ('en') {
    <h4>Company Details</h4>
    <p>AGROLAB GmbH</p>
    <p>Jenaer Str. 1</p>
    <p>84034 Landshut, Germany</p>
    <p>Tel: +49 0871 973091-0</p>
    <p>Fax: +49 0871 973091-99</p>
    <p>E-Mail: <a href="mailto:zentrale@agrolab.de">zentrale&#64;agrolab.de</a></p>

    <p>Internet:&nbsp;<a href="https://www.agrolab.com">www.agrolab.com</a></p>

    <h4>Managing Director:</h4>
    <p>Dr. Paul Wimmer (Managing Director)</p>
    <p>Dr. Torsten Zurmühl (Managing Director)</p>
    <p>Michael Witiska (Managing Director)</p>
    <p>Benoist Lasserre&nbsp; (Managing Director)</p>

    <h4>Head office:</h4>
    <p>Landshut</p>

    <h4>Registration court:</h4>
    <p>Landshut local court, HRB 7152</p>
    <p>VAT-ID-No.: DE DE 218 177 209</p>

    <h4>
      Person responsible: (The person responsible for the internet page is mentioned here, § 10
      Absatz 3 MDStV)
    </h4>
    <p>AGROLAB GmbH</p>
    <p>Renate Schwameis</p>
    <p>Jenaer Str. 1</p>
    <p>84034 Landshut</p>
    <p>Germany</p>
    <p class="imprint-link">
      <a href="https://www.agrolab.com/en/company-details.html" target="_blank">Company details</a>
    </p>
  }
  @case ('es') {
    <h4>Datos conf. art. 5 TMG (Ley de medios de telecomunicaciones de Alemania)</h4>

    <p>AGROLAB GmbH</p>
    <p>Jenaer Str. 1</p>
    <p>84034 Landshut</p>

    <h4>Representada por:</h4>
    <p>Dr. Paul Wimmer (Director ejecutivo)</p>
    <p>Dr. Torsten Zurmühl (Director ejecutivo)</p>
    <p>Michael Witiska (Director ejecutivo)</p>
    <p>Benoist Lasserre (Director ejecutivo)</p>

    <h4>Contacto</h4>
    <p>Tel: +49 0871 973091-0</p>
    <p>Fax: +49 0871 973091-99</p>

    <p>
      Correo electrónico
      <a title="Correo electrónico" href="mailto:zentrale@agrolab.de">zentrale&#64;agrolab.de</a>
    </p>

    <h4>Inscripción en el registro:</h4>
    <p>Tribunal de registro: Juzgado Municipal de Landshut</p>
    <p>HRB 7152</p>
    <h4>ID a efectos del IVA:</h4>
    <p>
      Número de identificación a efectos del IVA en conformidad con el art. 27a de la Ley alemana
      del IVA: DE DE 218 177 209.
    </p>

    <h4>
      Responsable de contenidos conf. art. 55 párrafo 2 RStV (Acuerdo sobre radio y medios de
      telecomunicaciones de Baviera):
    </h4>
    <p>AGROLAB GmbH</p>
    <p>Renate Schwameis</p>
    <p>Jenaer Str. 1</p>
    <p>84034 Landshut</p>
    <p class="imprint-link">
      <a href="https://www.agrolab.com/es/razon-social.html" target="_blank"
        >Razón social / Aviso legal</a
      >
    </p>
  }
  @case ('fr') {
    <h4>
      Informations conformes au § 5 de la loi allemande sur les médias électroniques (<em>TMG</em>)
    </h4>
    <p>AGROLAB GmbH</p>
    <p>Jenaer Str. 1</p>
    <p>84034 Landshut</p>

    <h4>Représentée par:</h4>
    <p>Dr. Paul Wimmer (Directeur)</p>
    <p>Dr. Torsten Zurmuehl (Directeur)</p>
    <p>Michael Witiska (Directeur)</p>
    <p>Benoist Lasserre (Directeur)</p>

    <h4>Contact:</h4>
    <p>Tel: +49 0871 973091-0</p>
    <p>Fax: +49 0871 973091-99</p>
    <p>E-Mail: <a href="mailto:zentrale@agrolab.de">zentrale&#64;agrolab.de</a></p>

    <h4>Inscription:</h4>
    <p>Tribunal chargé des inscriptions au RCS : tribunal de première instance de Landshut</p>
    <p>HRB 7152</p>

    <h4>N° d’identification TVA :</h4>
    <p>
      Numéro d’identification TVA conformément au §27a de la loi allemande relative à l’impôt sur le
      chiffre d’affaires (<em>Umsatzsteuergesetz</em>) : DE DE 218 177 209.
    </p>

    <h4>
      Responsable du contenu conformément au § 55 alinéa 2 du traité relatif à la radiodiffusion
      (<em>RStV</em>) :
    </h4>
    <p>AGROLAB GmbH</p>
    <p>Renate Schwameis</p>
    <p>Jenaer Str. 1</p>
    <p>84034 Landshut</p>
    <p class="imprint-link">
      <a href="https://www.agrolab.com/fr/nous-contacter.html" target="_blank"
        >Raison sociale / Mentions légales</a
      >
    </p>
  }
  @case ('it') {
    <p>AGROLAB GmbH</p>
    <p>Jenaer Str. 1</p>
    <p>84034 Landshut</p>

    <h4>Rappresentato da:</h4>
    <p>Dr. Paul Wimmer</p>
    <p>Dr. Torsten Zurmühl</p>
    <p>Michael Witiska</p>
    <p>Benoist Lasserre</p>

    <h4>Contatti:</h4>
    <p>Tel: +49 0871 973091-0</p>
    <p>Fax: +49 0871 973091-99</p>
    <p><a href="https://www.agrolab.com">www.agrolab.com</a></p>

    <h4>Sede principale:</h4>
    <p>Landshut</p>

    <h4>Registro di iscrizione:</h4>
    <p>Tribunale di Landshut, HRB 7152</p>
    <p>Partita IVA: DE DE 218 177 209</p>

    <h4>titolare del sito web:</h4>
    <p>AGROLAB GmbH</p>
    <p>Renate Schwameis</p>
    <p>Jenaer Str. 1</p>
    <p>84034 Landshut (GE)</p>
    <p class="imprint-link">
      <a href="https://www.agrolab.com/it/contatti.html" target="_blank">Dettagli dell'azienda</a>
    </p>
  }
  @case ('nl') {
    <h4>Gegevens conform § 5 Telemediengesetz [Duitse wet op de telecommunicatiemedia]</h4>
    <p>AGROLAB GmbH</p>
    <p>Jenaer Str. 1</p>
    <p>84034 Landshut</p>

    <h4>Vertegenwoordigd door:</h4>
    <p>Dr. Paul Wimmer (directie)</p>
    <p>Dr. Torsten Zurmuehl (directie)</p>
    <p>Michael Witiska (directie)</p>
    <p>Benoist Lasserre (directie)</p>

    <h4>Contact</h4>
    <p>Tel: +49 0871 973091-0</p>
    <p>Fax: +49 0871 973091-99</p>
    <p>E-Mail: <a href="mailto:zentrale@agrolab.de">zentrale&#64;agrolab.de</a></p>

    <h4>Registratie:</h4>
    <p>Kantoor van inschrijving: Kantonnale rechtbank Landshut</p>
    <p>HRB 7152</p>
    <h4>Omzetbelastingnummer:</h4>
    <p>
      Omzetbelastingnummer conform §27a Umsatzsteuergesetz [<em>Duitse wet op de omzetbelasting</em
      >]: DE DE 218 177 209.
    </p>

    <h4>
      Verantwoordelijke voor de inhoud conform § 55 lid 2 RStV [<em
        >Duits staatsverdrag voor omroepen</em
      >]:
    </h4>
    <p>AGROLAB GmbH</p>
    <p>Renate Schwameis</p>
    <p>Jenaer Str. 1</p>
    <p>84034 Landshut</p>
    <p class="imprint-link">
      <a href="https://www.agrolab.com/nl/bedrijfsdetails.html" target="_blank">Bedrijfsdetails</a>
    </p>
  }
  @case ('pl') {
    <h4>Dane zgodne z § 5 TMG (niemieckiej ustawy o mediach elektronicznych)</h4>
    <p>AGROLAB GmbH</p>
    <p>Jenaer Str. 1</p>
    <p>84034 Landshut, Germany</p>

    <h4>Osoby reprezentujące spółkę:</h4>
    <p>Dr. Paul Wimmer (Dyrektor zarządzający)</p>
    <p>Dr. Torsten Zurmühl (Dyrektor zarządzający)</p>
    <p>Michael Witiska (Dyrektor zarządzający)</p>
    <p>Benoist Lasserre (Dyrektor zarządzający)</p>

    <h4>Kontakt:</h4>
    <p>Tel: +49 0871 973091-0</p>
    <p>Fax: +49 0871 973091-99</p>

    <p>E-Mail: <a href="mailto:zentrale@agrolab.de">zentrale&#64;agrolab.de</a></p>

    <h4>Wpis do rejestru:</h4>
    <p>Sąd rejestrowy: Sąd Rejonowy w Landshut</p>
    <p>Nr wpisu: HRB 7152</p>

    <h4>Nr ident. podatkowej VAT:</h4>
    <p>
      Numer identyfikacji podatkowej VAT zgodnie z §27a niemieckiej ustawy o VAT: DE DE 218 177 209.
    </p>

    <h4>
      Osoba odpowiedzialna za treść w rozumieniu § 55 ust. 2 RStV (niemieckiej umowy państwowej o
      radiofonii i telewizji):
    </h4>
    <p>AGROLAB GmbH</p>
    <p>Renate Schwameis</p>
    <p>Jenaer Str. 1</p>
    <p>84034 Landshut</p>
    <p class="imprint-link">
      <a href="https://www.agrolab.com/pl/stopka.html" target="_blank">Stopka</a>
    </p>
  }
}
